angular.module('impactx.deliverycomplaint').controller('SimpleComplaintCtrl', SimpleComplaintCtrl);

SimpleComplaintCtrl.$inject = ['$scope', 'dataGen', 'ToolbarService', '$routeParams', '$redirect', 'BackService', 'ToastService',
    'TranslationService', 'OutsourcedCommentSaveService', '$q', '$mdDialog'];


function SimpleComplaintCtrl($scope, dataGen, ToolbarService, $routeParams, $redirect, BackService, ToastService,
                             TranslationService, OutsourcedCommentSaveService, $q, $mdDialog) {
    var self = this;

    $scope.showComments = {value: false};
    $scope.selectedItem = {value: null};

    var pohId = $routeParams.pohId || 0;
    var dnhId = $routeParams.dnhId || 0;

    var syncItemCache = {};

    var getParams = function() {
        var obj = {selection: {}};
        const lastParams = $redirect.getLastParameters();
        if (pohId) {
            obj.selection.type = 'POH';
            obj.selection.headerId = pohId;
            if (lastParams && lastParams.poiIds) {
                obj.selection.poiIds = lastParams.poiIds;
            }
        }
        if (dnhId) {
            obj.selection.type = 'DNH';
            obj.selection.headerId = dnhId;
            if (lastParams && lastParams.dniIds) {
                obj.selection.itemIds = lastParams.dniIds;
            }
            if (lastParams && lastParams.poiIds) {
                obj.selection.poiIds = lastParams.poiIds;
            }
        }
        return obj;
    };

    var getData = function () {
        dataGen.postAsForm($scope, getParams(), '/deliverycomplaint/simple/view').then(function() {
            if($scope.data) {
                ToolbarService.setButtons([
                    {
                        label: $scope.trns.save,
                        type: 'validation',
                        action: self.saveDialog,
                        params: {
                            form: $scope.dialogData,
                            disableExpression: {valueFunction: self.disableSave, error: $scope.trns.needOneItem}
                        }
                    },
                    {
                        label: $scope.trns.comments,
                        condition: self.canToggleShowComments,
                        type: 'dialogaction',
                        action: self.toggleShowComments
                    }
                ]);

                var scrollList = [];
                var allItems = [];
                angular.forEach($scope.data.complaintHeaders, function(header) {
                    // 'value' is for sorting with the same comparator that is used for the cards
                    // this means the entries are in the same order as the card are in the dialog
                    if (header.dnhId) {
                        scrollList.push({
                            id: 'header_'+header.dnhId,
                            value: header.dnhId,
                            label: $scope.trns.delNote+": "+header.deliveryNoteNumber.value
                        });
                    }
                    else {
                        scrollList.push({
                            id: 'header_0',
                            value: 0,
                            label: $scope.trns.notDeliveredItems
                        });
                    }
                    allItems = allItems.concat(header.selectedItems);
                });
                // sort first then add 'top' at first position
                scrollList = scrollList.sort($scope.zeroLastComparator);
                scrollList.unshift({id: 'top', label: $scope.trns.title});
                ToolbarService.setScrollMenu(scrollList);

                // initial sync
                var syncedPois = [];
                angular.forEach(allItems, function(item) {
                    if (syncedPois.indexOf(item.poiId) < 0) {
                        syncedPois.push(item.poiId);
                        self.syncItems(null, item);
                    }
                });
            }
        });
    };

    self.saveDialog = function () {

        var allowAskSendToSupplier = $scope.data.complaintHeaders.some(function (header) {
            return header.allowAskSendToSupplier;
        });

        if (allowAskSendToSupplier) {
            return $mdDialog.show({
                templateUrl: 'modules/deliverycomplaint/templates/simpleasksendtosupplierdialog.tmpl.html',
                controller: "SimpleComplaintAskSendToSupplierDialogCtrl",
                controllerAs: 'simpleComplaintAskSendToSupplierDialogCtrl',
                targetEvent: event,
                clickOutsideToClose: false,
                parent: angular.element(document.body),
                locals: {
                    trns: $scope.trns,
                    complaintHeaders: JSON.parse(JSON.stringify($scope.data.complaintHeaders))
                }
            }).then(function (result) {
                if (result) {
                    $scope.data.complaintHeaders = result;
                    self.save();
                }
            });
        } else {
            return self.save();
        }
    };

    self.save = function () {
        angular.forEach($scope.data.complaintHeaders, function (header) {
            angular.forEach(header.selectedItems, function(item) {
                cacheByToken(item)
            });
        });

        return dataGen.postAsForm({}, {data: $scope.data}, '/deliverycomplaint/simple/save').then(function(response) {
            if (impactX.isDefined(response, 'data.commentData.tokenMap')) {
                saveItemComments(response.data.commentData.tokenMap).then(function () {
                    dataGen.postAsForm({}, {cphIds: response.data.cphIds}, '/deliverycomplaint/postprocessing').then(function () {
                        ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                        BackService.back();
                    });
                }, function () {
                    restoreComments();
                });
            }
            else {
                restoreComments();
            }
        }, function () {
            restoreComments();
        });
    };

    var COMMENT_CACHE = {};
    function cacheByToken(source) {
        cacheOneCommentType(source.comments.internalComments);
        cacheOneCommentType(source.comments.externalComments);
    }

    function cacheOneCommentType(source) {
        if (source) {
            var newComments = source.newComments;
            var currentComment = {comment: source.newCommentInput.value};
            if (currentComment || (newComments && newComments.length > 0)) {
                var token = source.commentToken;
                source.newComments = [];
                COMMENT_CACHE[token] = {
                    newComments: newComments,
                    currentComment: currentComment
                };
            }
        }
    }

    function saveItemComments(newTokenMap) {
        var defer = $q.defer();
        if (newTokenMap) {
            var tokens = Object.getOwnPropertyNames(COMMENT_CACHE);
            saveOneItemCommentAndCallNext(tokens, 0, newTokenMap, defer);
        }
        return defer.promise;
    }

    function saveOneItemCommentAndCallNext(tokens, iterator, newTokenMap, defer){
        if (tokens.length > iterator) {
            var token = tokens[iterator];
            if (newTokenMap.hasOwnProperty(token)) {
                var commentObj = COMMENT_CACHE[token];
                var newComments = [].concat(commentObj.newComments);
                newComments.push(commentObj.currentComment);
                OutsourcedCommentSaveService.saveCommentsByToken(newTokenMap[token],
                    newComments, false).then(function () {
                    iterator++;
                    saveOneItemCommentAndCallNext(tokens, iterator, newTokenMap, defer)
                }, function () {
                    COMMENT_CACHE = {};
                    defer.reject();
                })
            }
        }
        else {
            COMMENT_CACHE = {};
            defer.resolve();
        }
    }

    function restoreComments() {
        angular.forEach($scope.data.complaintHeaders, function (header) {
            angular.forEach(header.selectedItems, function(item) {
                restoreOneCommentType(item.comments.internalComments);
                restoreOneCommentType(item.comments.externalComments);
            });
        });
    }

    function restoreOneCommentType(source) {
        if (source) {
            var token = source.commentToken;
            if (COMMENT_CACHE.hasOwnProperty(token)) {
                source.newComments = COMMENT_CACHE[token].newComments;
                source.newCommentInput.value = COMMENT_CACHE[token].currentComment.comment
                delete COMMENT_CACHE[token];
            }
        }
    }

    self.canToggleShowComments = function () {
        return $scope.selectedItem.value;
    };

    self.toggleShowComments = function () {
        $scope.showComments.value = !$scope.showComments.value;
    };

    self.removeItem = function($event, item, header, noSync) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        header.items.push(item);
        var index = header.selectedItems.indexOf(item);
        if (index >= 0) {
            header.selectedItems.splice(index, 1);
            item.isDeleted = true;
        }
        if (item.selected) {
            item.selected = false;
            $scope.selectedItem.value = null;
        }
        if(!noSync) {
            self.syncItems($event, item, true);
        }
    };

    self.removeAllItems = function ($event, header) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        var index = 0;
        while (header.selectedItems.length > index) {
            var item = header.selectedItems[index];
            if (item.readOnly) {
                index++;
            }
            else {
                self.removeItem($event, item, header);
            }
        }
    };

    self.recreateItem = function($event, item, header, noSync) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        header.selectedItems.push(item);
        var index = header.items.indexOf(item);
        if(index >= 0){
            header.items.splice(index, 1);
            item.isDeleted = false;
        }
        if(!noSync) {
            self.syncItems($event, item);
        }
    };

    self.recreateAllItems = function ($event, header) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        while (header.items.length > 0) {
            var item = header.items[0];
            self.recreateItem($event, item, header);
        }
    };

    self.syncItems = function ($event, item, forceUnsync) {
        if (item.dnhId) {
            angular.forEach($scope.data.complaintHeaders, function (header) {
                if (header.dnhId && item.dnhId !== header.dnhId) {
                    var allHeaderItems = [].concat(header.selectedItems);
                    // check if the current settings include or depend on other item's amounts (Return+AllDelivered, Return+Ordered, or any "open Amount")
                    // then sync the items
                    if (!forceUnsync && (item.treatment.setId === 201 || ((item.treatment.setId === 207 || item.treatment.setId === 208)
                        && item.complainedAmount.selected && item.complainedAmount.selected.id !== 2))) {
                        // for this part also check deleted items
                        angular.forEach(allHeaderItems.concat(header.items), function (entry) {
                            // if there is an entry for a different dni but the same poi
                            if (item.dniId !== entry.dniId && item.poiId === entry.poiId) {
                                // sync the found entry to match the current, but cache the old settings
                                var cacheKey = entry.dniId + '_' + entry.poiId;
                                // only cache if not already cached
                                if (!syncItemCache[cacheKey]) {
                                    syncItemCache[cacheKey] = angular.copy(entry);
                                    // if the found entry was a deleted entry, recreate it
                                    if (entry.isDeleted) {
                                        self.recreateItem($event, entry, header, true);
                                    }
                                }
                                entry.treatment = item.treatment;
                                entry.complainedAmount = item.complainedAmount;
                                entry.complainedAmountFree = item.complainedAmountFree;
                                entry.sendMail = item.sendMail;
                                entry.readOnly = true;
                            }
                        });
                    }
                    else { // unsync the items if the options do not match anymore
                        angular.forEach(allHeaderItems, function (entry) {
                            // if there is an entry for a different dni but the same poi
                            if (item.dniId !== entry.dniId && item.poiId === entry.poiId) {
                                var cacheKey = entry.dniId + '_' + entry.poiId;
                                // if there is a cache entry, then the item was synced
                                if (syncItemCache[cacheKey]) {
                                    entry.treatment = syncItemCache[cacheKey].treatment;
                                    entry.complainedAmount = syncItemCache[cacheKey].complainedAmount;
                                    entry.complainedAmountFree = syncItemCache[cacheKey].complainedAmountFree;
                                    entry.sendMail = syncItemCache[cacheKey].sendMail;
                                    entry.isDeleted = syncItemCache[cacheKey].isDeleted;
                                    entry.readOnly = false;
                                    syncItemCache[cacheKey] = undefined;
                                    // if the entry was deleted before the sync, delete it again
                                    if (entry.isDeleted) {
                                        self.removeItem($event, entry, header, true);
                                    }
                                }
                            }
                        });
                    }
                }
            });
        }
    };

    $scope.zeroLastComparator = function(value1, value2) {
        var num1 = Number(value1.value);
        var num2 = Number(value2.value);
        if(num2 === 0) {
            num2 = num1+1;
        }
        if(num1 === 0) {
            num1 = num2+1;
        }
        return num1-num2;
    };

    self.disableSave = function() {
        // disable the save button if all items are "deleted".
        var len = $scope.data.complaintHeaders.length;
        for(var i=0; i<len; i++) {
            if($scope.data.complaintHeaders[i].selectedItems.length > 0) {
                return false;
            }
        }
        return true;
    };

    getData();
}